export const getDxAiPatientClinicMuiAppBar = (palette: any) => ({
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: "none",
      },
      colorDefault: {
        backgroundColor: palette["primary-container"].main,
        backgroundImage: "none",
        padding: "1rem",
      },
    },
  },
});
